import React, { useEffect, useRef, useState } from "react";
import "./MobileCarbonReader.css";

const READING_DISTANCE_VH = 1.8;
const CHANGE_AFTER_VH = 0.85;

export const MobileCarbonReader = ({ renderPanel, children }) => {
  const track = useRef(null);
  const panel = useRef(null);
  const [removed, setRemoved] = useState(false);
  const [size, setSize] = useState({ panel: 0, viewport: window.innerHeight });
  const stickyTop = Math.min(96, size.viewport - size.panel - 16);

  useEffect(() => {
    const measure = () => setSize({
      panel: Math.ceil(panel.current.getBoundingClientRect().height),
      viewport: window.innerHeight,
    });
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(panel.current);
    window.addEventListener("resize", measure);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, []);

  useEffect(() => {
    const onScroll = () => {
      const distance = stickyTop - track.current.getBoundingClientRect().top;
      setRemoved(distance >= size.viewport * CHANGE_AFTER_VH);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [size.viewport, stickyTop]);

  return (
    <div className="bg-2" data-testid="carbon-section" data-state={removed ? "removed" : "avoided"}>
      <section ref={track} style={{ height: size.panel + size.viewport * READING_DISTANCE_VH }} data-testid="carbon-mobile-reading-track">
        <div ref={panel} className="carbon-mobile-reading-panel sticky px-6 py-8" style={{ top: stickyTop }} data-testid="carbon-mobile-reading-panel">
          {renderPanel(removed)}
        </div>
      </section>
      <section className="px-6 py-20 border-t border-line">{children}</section>
    </div>
  );
};